<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/officeLocations"
        >Content Management - Office Locations</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">
      Edit Office Locations
    </h3>
    <div class="detailContent">
      <el-form
        label-width="50%"
        label-position="left"
        ref="formLocation"
        :model="formLocation"
        :rules="formLocationRules"
      >
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Country / Region" prop="country">
              <el-select v-model="formLocation.country" filterable>
                <el-option
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.name"
                  :value="item.countryId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office Name / City (EN)" prop="cityEn">
              <el-input
                v-model="formLocation.cityEn"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office Name / City (JP)" prop="cityJp">
              <el-input
                v-model="formLocation.cityJp"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office Name / City (TC)" prop="cityTc">
              <el-input
                v-model="formLocation.cityTc"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office Name / City (SC)" prop="citySc">
              <el-input
                v-model="formLocation.citySc"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office address (EN)" prop="addressEn">
              <el-input
                v-model="formLocation.addressEn"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office address (JP)" prop="addressJp">
              <el-input
                v-model="formLocation.addressJp"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office address (TC)" prop="addressTc">
              <el-input
                v-model="formLocation.addressTc"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office address (SC)" prop="addressSc">
              <el-input
                v-model="formLocation.addressSc"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Post online" prop="post">
              <el-radio v-model="formLocation.post" :label="true">On</el-radio>
              <el-radio v-model="formLocation.post" :label="false"
                >Off</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Order" prop="order">
              <el-input v-model="formLocation.order" maxlength="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Last update by">
              <p>{{ formLocation.updateBy }}</p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button v-if="showSave" class="reset" style="width: 100%" @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4">
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleSave"
          >Save</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCountry, officesDetail, officesUpdate } from "@/request/api";
export default {
  name: "editOfficeLocation",
  data() {
    return {
      formLocationRules: this.$validation.locationCreate,
      formLocation: {
        cityEn: "",
        cityJp: "",
        cityTc: "",
        citySc: "",
        addressEn: "",
        addressJp: "",
        addressTc: "",
        addressSc: "",
        post: false,
        order: "",
        country: "",
        updateBy: "",
      },
      countryList: [],
      showSave: true,
    };
  },
  methods: {
    getConfig(callback) {
      getCountry().then((res) => {
        this.countryList = res.data;
        if (callback) callback();
      });
    },
    handleCancel() {
      this.$router.push("/officeLocations");
    },
    handleSave() {
      this.$refs.formLocation.validate((valid) => {
        if (valid) {
          let params = {
            addressEn: this.formLocation.addressEn,
            addressJp: this.formLocation.addressJp,
            addressSc: this.formLocation.addressSc,
            addressTc: this.formLocation.addressTc,
            cityEn: this.formLocation.cityEn,
            cityJp: this.formLocation.cityJp,
            citySc: this.formLocation.citySc,
            cityTc: this.formLocation.cityTc,
            displayOrder: this.formLocation.order,
            post: this.formLocation.post,
            countryId: this.formLocation.country,
          };
          let id = this.$route.params.id;
          officesUpdate(id, params).then((res) => {
            if (res.data.status == "00") {
              this.$message.success("The changes have been saved");
              this.handleCancel();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    getDetail() {
      let id = this.$route.params.id;
      officesDetail(id).then((res) => {
        if (res.data.status == "00") {
          this.formLocation.country = res.data.payload.countryId;
          this.formLocation.post = res.data.payload.post;
          this.formLocation.order = res.data.payload.displayOrder;
          this.formLocation.cityEn = res.data.payload.cityEn;
          this.formLocation.cityJp = res.data.payload.cityJp;
          this.formLocation.cityTc = res.data.payload.cityTc;
          this.formLocation.citySc = res.data.payload.citySc;
          this.formLocation.addressEn = res.data.payload.addressEn;
          this.formLocation.addressJp = res.data.payload.addressJp;
          this.formLocation.addressTc = res.data.payload.addressTc;
          this.formLocation.addressSc = res.data.payload.addressSc;
          this.formLocation.updateBy =
            res.data.payload.updatedByName && res.data.payload.updatedAt
              ? res.data.payload.updatedByName +
                " , " +
                this.$commonjs.paramFormatDate(res.data.payload.updatedAt)
              : "-";
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },
  },
  created: function () {
    this.getConfig(this.getDetail());
    this.showBtn("CONTENT_WRITE");
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/content/location/editOfficeLocation.vue